import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ShoppingCart, FileText, Package, UserPlus } from "lucide-react";
import { usePermissoes } from "@/contexts/PermissoesContext";
import { FORMULARIOS } from "@/domain/formularios";

const actions = [
  { label: "Nova Venda", icon: ShoppingCart, variant: "default" as const, to: "/operacional/dav/novo", formularioId: FORMULARIOS.DAV },
  { label: "Emitir NF-e", icon: FileText, variant: "secondary" as const, to: "/fiscal/notas-fiscais/nova", formularioId: FORMULARIOS.EMISSAO_NFE },
  { label: "Cadastrar Produto", icon: Package, variant: "outline" as const, to: "/produtos/novo", formularioId: FORMULARIOS.PRODUTOS },
  { label: "Novo Cliente", icon: UserPlus, variant: "outline" as const, to: "/pessoas/novo", formularioId: FORMULARIOS.PESSOAS_EMPRESAS },
];

export function QuickActions({ modoEdicao = false }: { modoEdicao?: boolean } = {}) {
  const navigate = useNavigate();
  const { temPermissao } = usePermissoes();

  // Ações de criação: exigem ler (a rota é protegida por leitura) + incluir.
  const visiveis = actions.filter(
    (a) => temPermissao(a.formularioId, "ler") && temPermissao(a.formularioId, "incluir")
  );

  if (visiveis.length === 0 && !modoEdicao) return null;

  return (
    <Card className="shadow-card border-border/50 h-full flex flex-col">
      <CardHeader className="pb-3">
        <CardTitle className="font-heading text-base">Ações Rápidas</CardTitle>
        <CardDescription className="text-xs">Acesso rápido às funções mais usadas</CardDescription>
      </CardHeader>
      <CardContent className="flex-1 overflow-auto">
        {visiveis.length === 0 ? (
          <p className="py-6 text-center text-sm text-muted-foreground">
            Nenhuma ação disponível para o seu perfil.
          </p>
        ) : (
          <div className="grid grid-cols-2 gap-2.5">
            {visiveis.map((action) => (
              <Button key={action.label} variant={action.variant} className="h-auto py-4 flex-col gap-2 text-xs font-medium" onClick={() => navigate(action.to)}>
                <action.icon className="h-5 w-5" />
                <span>{action.label}</span>
              </Button>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
